module.exports = __webpack_public_path__ + "static/img/cgpt_img_bzt.4377fc0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/cgpt_img_bzt.png
// module id = +5sh
// module chunks = 0